import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { TechnicusFeedRegistrationDto } from "./types";
import { jobSyncQueryKeys } from "../query-keys";

import { instance } from "@/lib/axios/instance";

export function useTechnicusFeedRegistration(
  clientId: string | undefined
): UseQueryResult<TechnicusFeedRegistrationDto, AxiosError> {
  return useQuery({
    queryKey: jobSyncQueryKeys.feedRegistration("technicus", clientId),
    queryFn: () =>
      instance
        .get<TechnicusFeedRegistrationDto>(
          `/api/v2/Integrations/technicus/job-sync/feed-registration`,
          {
            params: {
              clientId,
            },
          }
        )
        .then((res) => {
          const raw = res.data as unknown;
          const paginated = raw as { data?: TechnicusFeedRegistrationDto[]; Data?: TechnicusFeedRegistrationDto[] };
          if (Array.isArray(paginated?.data) && paginated.data[0] != null) return paginated.data[0];
          if (Array.isArray(paginated?.Data) && paginated.Data[0] != null) return paginated.Data[0];
          return raw as TechnicusFeedRegistrationDto;
        }),
    enabled: !!clientId,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
